//@ts-nocheck
export const generateGUID = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0; // Generate a random number
      const v = c === 'x' ? r : (r & 0x3) | 0x8; // Adjust for 'x' or 'y'
      return v.toString(16); // Convert to hexadecimal
    });
  };